/* HMBLE cookie banner, granular consent (essential + analytics + marketing).
 * Choices persisted in localStorage and piped through Shopify Customer Privacy API.
 * Essential is always granted (technical cookies needed for cart/session/security).
 * Any element with [data-cookies-open] reopens the preferences panel.
 */

(() => {
  const KEY = 'hmble.cookie-consent.v2';
  const SHOW_DELAY_MS = 600;

  const readStored = () => {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (typeof parsed === 'object' && parsed !== null) return parsed;
    } catch (_) {}
    return null;
  };

  const applyConsent = (consent) => {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    try {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        () => {
          if (!window.Shopify.customerPrivacy) return;
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              analytics: !!consent.analytics,
              marketing: !!consent.marketing,
              preferences: !!consent.marketing,
              sale_of_data: !!consent.marketing,
            },
            () => {}
          );
        }
      );
    } catch (_) { /* silently fail; banner UX still works */ }
  };

  const init = () => {
    const banner = document.querySelector('[data-hmble-cookies]');
    if (!banner) return;

    const viewCompact = banner.querySelector('[data-cookies-view="compact"]');
    const viewPanel = banner.querySelector('[data-cookies-view="panel"]');
    const boxAnalytics = banner.querySelector('[data-consent-cat="analytics"]');
    const boxMarketing = banner.querySelector('[data-consent-cat="marketing"]');

    const finalize = (consent) => {
      try { localStorage.setItem(KEY, JSON.stringify(consent)); } catch (_) {}
      applyConsent(consent);
      banner.classList.add('is-leaving');
      setTimeout(() => {
        banner.hidden = true;
        banner.classList.remove('is-leaving');
      }, 280);
    };

    const showPanel = () => {
      if (!viewPanel || !viewCompact) return;
      viewCompact.hidden = true;
      viewPanel.hidden = false;
      boxAnalytics?.focus();
    };

    const showCompact = () => {
      if (!viewPanel || !viewCompact) return;
      viewPanel.hidden = true;
      viewCompact.hidden = false;
    };

    banner.querySelector('[data-cookies-accept]')?.addEventListener('click', () => {
      finalize({ analytics: true, marketing: true });
    });

    banner.querySelector('[data-cookies-reject]')?.addEventListener('click', () => {
      finalize({ analytics: false, marketing: false });
    });

    banner.querySelector('[data-cookies-customize]')?.addEventListener('click', showPanel);
    banner.querySelector('[data-cookies-back]')?.addEventListener('click', showCompact);

    banner.querySelector('[data-cookies-save]')?.addEventListener('click', () => {
      finalize({ analytics: !!boxAnalytics?.checked, marketing: !!boxMarketing?.checked });
    });

    /* Reopen from any [data-cookies-open] element (e.g. footer link): show the panel with the current choices. */
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest && event.target.closest('[data-cookies-open]');
      if (!trigger) return;
      event.preventDefault();
      const current = readStored() || { analytics: false, marketing: false };
      if (boxAnalytics) boxAnalytics.checked = !!current.analytics;
      if (boxMarketing) boxMarketing.checked = !!current.marketing;
      banner.classList.remove('is-leaving');
      banner.hidden = false;
      showPanel();
    });

    const stored = readStored();
    if (stored) {
      applyConsent(stored);
      return;
    }

    setTimeout(() => { banner.hidden = false; }, SHOW_DELAY_MS);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
